import { useDisplaySettings } from './useDisplaySettings'

export function useSetDemoMode() {
  const [, setDisplaySettings] = useDisplaySettings()

  return (demoModeAccountSlug: string | null) => {
    setDisplaySettings((displaySettings) => {
      return {
        ...displaySettings,
        demo_mode: {
          stream_speed: 'default',
          ...displaySettings.demo_mode,
          account_slug: demoModeAccountSlug,
        },
      }
    })
  }
}

export function useDisableDemoMode() {
  const setDemoMode = useSetDemoMode()

  return () => {
    setDemoMode(null)
  }
}
